/* global window */

import videojs from 'video.js';
import get from 'lodash/get';

/**
 * Class representing Recommendations Tracker.
 */
class RecTracker {
  /**
   * Create a RecTracker instance.
   */
  constructor() {
    this.recommendationIndex = 0;
    this.skipWaitClicked = false;
    this.cancelRecClicked = false;
  }

  /**
   * Resets RecTracker.
   */
  clear() {
    this.recommendationIndex = 0;
    this.skipWaitClicked = false;
    this.cancelRecClicked = false;
  }

  /**
   * Returns current recommendations index.
   * @return {integer} recommendations index
   */
  get index() {
    return this.recommendationIndex;
  }

  /**
   * Check if recommendations are available.
   * @return {boolean}
   */
  get hasRecommendations() {
    if (!get(window, 'hearstPlayer.recommendations')) {
      return false;
    }

    const recsEmpty = window.hearstPlayer.recommendations.length === 0;

    return !recsEmpty;
  }

  /**
   * Returns the nex Video Embed source from recommendations list.
   * @return {Object}
   */
  getNextRec() {
    if (!this.hasRecommendations) {
      return null;
    }

    const nextRecSource = window.hearstPlayer.recommendations.pop();

    this.recommendationIndex++;
    this.skipWaitClicked = false;
    this.cancelRecClicked = false;

    return nextRecSource;
  }

  /**
   * Stores Video Embed ID in local storage watched object.
   * @param {string} embedId - Video Embed ID
   */
  setRecWatched(embedId) {
    const key = 'hearstLumiereWatched';

    let watched = localStorage.getItem(key);
    if (!watched) {
      watched = [];
    } else {
      try {
        watched = JSON.parse(watched);
      } catch (ex) {
        videojs.log.error(ex);
        watched = [];
      }
    }

    if (watched.includes(embedId)) {
      return;
    }

    watched.push(embedId);

    localStorage.setItem(key, JSON.stringify(watched));
  }

  /**
   * Sets wait skip status.
   * @param {boolean} state - clicked state
   */
  setSkipWaitClicked(state) {
    this.skipWaitClicked = state;
  }

  /**
   * Sets cancel recommendation status.
   * @param {boolean} state - clicked state
   */
  setCancelRecClicked(state) {
    this.cancelRecClicked = state;
  }
}

export default RecTracker;
